<template>
  <div class="container-table">
    <b-table
      thead-tr-class="table-row-head"
      tbody-tr-class="table-body-head"
      bordered
      :items="items[1]"
      :fields="items[0]"
    >
    </b-table>
  </div>
</template>
<script>
export default {
  props: ["items"],
};
</script>
<style>
.container-table {
  padding: 0.5rem 0rem;
}
.table-row-head {
  background: #efefef;
  color: rgb(36, 198, 171);
}
.table-body-head {
  background: white;
}
.table-body-head:hover {
  background: white !important;
}
.table-row-head:hover {
  background: #efefef !important;
}
td {
  font-size: 0.8rem !important;
}
td.table-primary {
  background: #efefef !important;
  color: #24C6AB !important;
  font-weight: 600;
}
</style>
